import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import TopLiveBanner from '../containers/banner/TopLiveBanner';
// import TopThemeBanner from "../containers/banner/TopThemeBanner";
//import TopMovieBanner from '../containers/banner/TopMovieBanner';

import TopEventBanner from '../containers/banner/TopEventBanner';
import BarBannerItem from '../components/banner/BarBannerItem';
import TopRollingBanner from '../containers/banner/TopRollingBanner';

import ViewContent from '../containers/main/ViewContent';
import UpdateContent from '../containers/main/UpdateContent';
import SameTimeContent from '../containers/main/SameTimeContent';
import PopularContent from '../containers/main/PopularContent';
import OnAir from '../containers/main/OnAir';
import Chuchon from '../containers/main/Chuchon';
import TagContent from '../containers/main/TagContent';
import ThemeContent from '../containers/main/ThemeContent';
import ShopBanner from '../containers/banner/ShopBanner';
import NewReserveGoodsSwiper from '../containers/shop/NewReserveGoodsSwiper';
import Exhibition from '../containers/shop/Exhibition';
// import SameGenreContent from "../containers/main/SameGenreContent";

import moment from 'moment';
import Footer from '../components/Footer';
import ShopFooter from '../components/ShopFooter';
// import { loadProgressBar } from "axios-progress-bar";
import { isMobile, isAndroid, isIOS } from 'react-device-detect';
// import { confirmAlert } from "react-confirm-alert";
import { dropByCacheKey } from 'react-router-cache-route';

//import { useQuery } from 'react-query'
//import { isArrayLike } from 'lodash';

//import { QueryClientProvider, QueryClient } from 'react-query'
//const queryClient = new QueryClient();

class Main extends Component {
  state = {
    bannerType: 'event',
  };
  focusListener = null;
  componentDidMount = () => {
    const { history } = this.props;

    // if (isMobile) {
    //   alert(
    //     "PC 전용 사이트로 모바일 해상도를 지원하지 않습니다.\n확인을 누르시면 전용 앱 또는 스토어로 이동합니다."
    //   );
    //   this._movieStore();
    // }
    // history.push('/event/323');
    // return;
    this._getBanner();

    const date = moment(new Date()).format('HH:mm');
    //console.log(date)

    // if (date > "10:00" && date < "10:30") {
    //   //console.log('오후')
    //   this.setState({
    //     bannerType: "event",
    //   });
    // } else if (date > "22:00" && date < "23:59") {
    //   //console.log('새벽')
    //   this.setState({
    //     bannerType: "live",
    //   });
    // } else if (date > "00:00" && date < "02:00") {
    //   //console.log('일반')
    //   this.setState({
    //     bannerType: "live",
    //   });
    // } else {
    //   //const num = Math.floor(Math.random()*(2-1+1)) + 1;

    //   //if(num === 1) {
    //   this.setState({
    //     bannerType: "event",
    //   });

    // }

    /*
        this.setState({
            bannerType: 'live'
        })
        */
  };

  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.loginId !== nextProps.loginId;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    // const { history } = this.props;
    //console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)
    if (this.props.loginId !== nextProps.loginId) {
      //setTimeout(()=>{
      //history.push('/')
      dropByCacheKey('main');
      //clearCache()
      //window.location.replace('/');
      //}, 5000)
    }
  };
  _movieStore = () => {
    if (isIOS) {
      console.log('ios');
      setTimeout(function () {
        window.open('https://itunes.apple.com/kr/app/id687631772', '', '');
      }, 1500);

      window.location.href = 'aniplustv://';
    } else if (isAndroid) {
      console.log('andorid');
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);

      window.location.href = 'aniplustv://';
    } else {
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);
    }
  };
  _getBanner = async () => {
    //const { data, isLoading } = useQuery('banner', await this._getBannerApi)
    //if(isLoading) {
    //    console.log('loading...')
    //}

    /*
        const result = await queryClient.fetchQuery('banner', this._getBannerApi, {
            cacheTime: 3000,
            refetchOnMount: false
        })
        */

    const result = await this._getBannerApi();
    const intReturn = result.data[0].intReturn;
    const barBannerList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        barBannerList,
      });
    }
  };
  _getBannerApi = () => {
    const { apiUrl } = this.props;
    //loadProgressBar()

    return axios(apiUrl + '/topBannerBar')
      .then((response) => response)
      .catch((error) => {
        //console.log('error....')
      });
  };
  _onClick = (url, target) => {
    const { history } = this.props;

    if (target === '_blank') {
      window.open(url, '', '');
    } else {
      history.push(url);
    }
  };

  _goLogin = () => {
    const { history } = this.props;
    history.push('/login');
  };
  _goJoin = () => {
    const { history } = this.props;
    history.push('/join');
  };
  _goList = () => {
    const { history } = this.props;
    history.push('/list');
  };
  _goChat = () => {
    //const { history } = this.props;
    //history.push('/chat')
    window.open('http://www.aniplustv.com/tv/ifr_chatting_intro.asp', '', '');
  };
  _goChat1 = () => {
    const { history } = this.props;
    history.push('/chat');
  };
  _goLive = () => {
    const { history } = this.props;
    history.push('/livePlayer');
  };
  _goTicket = () => {
    const { history } = this.props;
    history.push('/ticket');
  };

  render() {
    const { barBannerList, bannerType } = this.state;
    const { loginId, serviceEndDate } = this.props;
    const jbRandom = Math.random();

    return (
      <Fragment>
        {/* {isMobile ? (
          <div
            style={{
              color: "#fff",
              textAlign: "center",
              paddingTop: 100,
            }}
          >
            <p>
              <img src="/img/logo.png" style={{ width: 130 }} />
            </p>
            <p style={{ paddingTop: 20, fontSize: 15 }}>
              모바일에서 지원되지 않는 페이지입니다.
            </p>
            <p style={{ fontSize: 15 }}>전용앱을 이용해주세요.</p>
            <p
              onClick={this._movieStore}
              style={{
                paddingTop: 15,
                color: "#ff5d24",
                fontSize: 15,
                fontWeight: 800,
              }}
            >
              전용앱으로 열기
            </p>
          </div>
        ) : ( */}
        <>
          <div className="content" style={{ paddingTop: 0 }}>
            {/* {bannerType === 'live' ? (
              <TopLiveBanner param={jbRandom} />
            ) : (
              <TopEventBanner param={jbRandom} />
            )} */}
            <TopEventBanner param={jbRandom} />

            <TopRollingBanner />
            <div>
              {' '}
              {/*className="padding_70"*/}
              {barBannerList ? (
                barBannerList[0] ? (
                  <BarBannerItem
                    index={1}
                    bannerFile={barBannerList[0].bannerFile}
                    bannerFile_s={barBannerList[0].bannerFile_s}
                    LinkURL={barBannerList[0].LinkURL}
                    Linktarget={barBannerList[0].Linktarget}
                    LinkURL_M={barBannerList[0].LinkURL_M}
                    Linktarget_M={barBannerList[0].Linktarget_M}
                    idx={barBannerList[0].idx}
                    comment={barBannerList[0].comment}
                    adComIdx={barBannerList[0].adComIdx}
                    pageCode={barBannerList[0].pageCode}
                  />
                ) : null
              ) : null}
              <div>
                <ShopBanner type={'main'} id={'main-page'} />
              </div>
              <div>
                <NewReserveGoodsSwiper type={'reserve'} />
              </div>
              <div>
                <Exhibition />
              </div>
              {loginId ? null : <div style={{ paddingTop: 20 }}></div>}
              {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
              serviceEndDate ? null : (
                <>
                  <ViewContent />
                  <UpdateContent />
                </>
              )}
              <div className={isMobile ? 'padding_72' : 'padding_71'}>
                <SameTimeContent refer={'sametime'} />
              </div>
              <div>
                <Chuchon />
              </div>
              <div className={isMobile ? 'padding_72' : 'padding_71'}>
                <SameTimeContent refer={'rank'} />
              </div>
              {barBannerList ? (
                barBannerList[1] ? (
                  <BarBannerItem
                    index={2}
                    bannerFile={barBannerList[1].bannerFile}
                    bannerFile_s={barBannerList[1].bannerFile_s}
                    LinkURL={barBannerList[1].LinkURL}
                    Linktarget={barBannerList[1].Linktarget}
                    LinkURL_M={barBannerList[1].LinkURL_M}
                    Linktarget_M={barBannerList[1].Linktarget_M}
                    idx={barBannerList[1].idx}
                    comment={barBannerList[1].comment}
                    adComIdx={barBannerList[1].adComIdx}
                    pageCode={barBannerList[1].pageCode}
                  />
                ) : null
              ) : null}
              <div>
                <ShopBanner type={'mdpick'} id={'sub-page'} />
              </div>
              <div>
                <NewReserveGoodsSwiper type={'stock'} />
              </div>
              {/*주간리그*/}
              {/*
                        <div className="main_list_style padding_top">
                            <h1><strong>주간 리그 TOP10</strong><span className="on">캐릭터</span><span>성우</span><div><em className="on"></em><em></em><em></em><a href="#">더보기</a></div></h1>
                            <div className="main_list_goup2">
                                <div className="div_ul">
                                    <div className="div_li">
                                        <em className="em_on">1</em>
                                        <div className="list_img_bg"><img src="img/test_img2.png"/></div>
                                        <p>카구야님은 고백받고 싶어 ~</p> 
                                        <span>제2화. 녀석들이 미워</span>
                                        <strong>2,000</strong>
                                        <img src="img/heart_max.png" className="top10_add"/>
                                    </div>
                                    <div className="div_li">
                                        <em>2</em>
                                        <div className="list_img_bg"><img src="img/test_img2.png"/></div>
                                        <p>카구야님은 고백받고 싶어 ~</p> 
                                        <span>제2화. 녀석들이 미워</span>
                                        <strong>2,000</strong>
                                        <img src="img/heart_max.png" className="top10_add"/>
                                    </div>
                                    <div className="div_li">
                                        <em>3</em>
                                        <div className="list_img_bg"><img src="img/test_img2.png"/></div>
                                        <p>카구야님은 고백받고 싶어 ~</p> 
                                        <span>제2화. 녀석들이 미워</span>
                                        <strong>2,000</strong>
                                        <img src="img/heart_max.png" className="top10_add"/>
                                    </div>
                                    <div className="div_li">
                                        <em>4</em>
                                        <div className="list_img_bg"><img src="img/test_img2.png"/></div>
                                        <p>카구야님은 고백받고 싶어 ~</p> 
                                        <span>제2화. 녀석들이 미워</span>
                                        <strong>2,000</strong>
                                        <img src="img/heart_max.png" className="top10_add"/>
                                    </div>
                                    <div className="div_li">
                                        <em>5</em>
                                        <div className="list_img_bg"><img src="img/test_img2.png"/></div>
                                        <p>카구야님은 고백받고 싶어 ~</p> 
                                        <span>제2화. 녀석들이 미워</span>
                                        <strong>2,000</strong>
                                        <img src="img/heart_max.png" className="top10_add"/>
                                    </div>
                                </div>
                                <div className="clear"></div>
                            </div>
                        </div>
                        */}
              {/*주간리그 끝*/}
              {/*인기작품*/}
              {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
              serviceEndDate ? null : (
                <PopularContent />
              )}
              {/*인기작품*/}
              {/*지금방송중*/}
              {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
              serviceEndDate ? null : (
                <OnAir />
              )}
              {/*지금방송중*/}
              {/* {barBannerList ? (
                barBannerList[2] ? (
                  <BarBannerItem
                    index={3}
                    bannerFile={barBannerList[2].bannerFile}
                    bannerFile_s={barBannerList[2].bannerFile_s}
                    LinkURL={barBannerList[2].LinkURL}
                    Linktarget={barBannerList[2].Linktarget}
                    LinkURL_M={barBannerList[2].LinkURL_M}
                    Linktarget_M={barBannerList[2].Linktarget_M}
                    idx={barBannerList[2].idx}
                    comment={barBannerList[2].comment}
                    adComIdx={barBannerList[2].adComIdx}
                    pageCode={barBannerList[2].pageCode}
                  />
                ) : null
              ) : null} */}
              {/*인기 태그 작품*/}
              {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
              serviceEndDate ? null : (
                <TagContent contentSerial={0} />
              )}
              {/*비슷한 작품*/}
              {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
              serviceEndDate ? null : (
                <ThemeContent />
              )}
              {/*
                        <SameGenreContent 
                            contentSerial={0}
                        />
                        */}
            </div>
          </div>
          {/*풋터 */}
          {/* <Footer /> */}
          <ShopFooter />
        </>
        {/* )} */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Main));
